// extracted by mini-css-extract-plugin
export default {"Strawberry":"Strawberry_Strawberry__KM2kq"};